import { useCallback } from 'react';
import {
  useQAPairConversationKnowledgeQuery,
  useSetQAPairConversationKnowledgeQuery,
} from './useQAPair';
import {
  MAX_QUERY_HUMAN_REPLY_MSG_MAP_SIZE,
  useGetQAPairQueryHumanReplyMsgMap,
} from './useQAPairHumanReply';
import { isIdEqual } from 'utils/is';
import { useCleanQAPair } from './useCleanQAPair';
import { clearKnowledgeQuery } from 'services/api/supplementKnowledge';
import { noop } from 'lodash-es';

export const useGetConversationKnowledgeQueryMsgId = () => {
  const conversationKnowledgeQuery = useQAPairConversationKnowledgeQuery();
  const getQAPairQueryHumanReplyMsgMap = useGetQAPairQueryHumanReplyMsgMap();
  const cleanQAPair = useCleanQAPair();

  const setQAPairConversationKnowledgeQuery = useSetQAPairConversationKnowledgeQuery();

  return useCallback(
    (conversationId: string) => {
      if (!conversationKnowledgeQuery) {
        return;
      }

      const {
        conversationId: queryConversationId,
        knowledgeQuery,
        knowledgeReply,
      } = conversationKnowledgeQuery;

      let queryMsgId = '';
      let clearConversationKnowledgeQuery: () => void = noop;
      if (isIdEqual(queryConversationId, conversationId)) {
        if (knowledgeQuery) {
          queryMsgId = knowledgeQuery.msgId;
          clearConversationKnowledgeQuery = () => {
            setQAPairConversationKnowledgeQuery({
              ...conversationKnowledgeQuery,
              knowledgeQuery: undefined,
            });
          };
        }
        if (knowledgeReply) {
          queryMsgId = knowledgeReply.msgId;
          clearConversationKnowledgeQuery = () => {
            setQAPairConversationKnowledgeQuery({
              ...conversationKnowledgeQuery,
              knowledgeReply: undefined,
            });
          };
        }
      }

      if (!queryMsgId) {
        return;
      }

      const queryHumanReplyMsgMap = getQAPairQueryHumanReplyMsgMap(queryMsgId);
      if (
        queryHumanReplyMsgMap &&
        queryHumanReplyMsgMap.size >= MAX_QUERY_HUMAN_REPLY_MSG_MAP_SIZE
      ) {
        if (isIdEqual(queryConversationId, conversationId)) {
          cleanQAPair();
          clearConversationKnowledgeQuery();
          clearKnowledgeQuery(conversationId);
        }
        return;
      }

      return queryMsgId;
    },
    [
      cleanQAPair,
      conversationKnowledgeQuery,
      getQAPairQueryHumanReplyMsgMap,
      setQAPairConversationKnowledgeQuery,
    ],
  );
};
